import req from './apis'
import { service_url } from './getDomain'

export function list(body) {
    return req.get({
        url: service_url + '/goods/queryGoods',
        body
    }).then(function (data) {
        return data
    })
}
export function details(body) {
    return req.get_listDetails({
        url: service_url + '/goods',
        body
    }).then(function (data) {
        return data
    })
}
export function immediately_buy(body) {
    return req.postForm({
        url: service_url + '/loginOrReg',
        body
    }).then(function (data) {
        return data
    })
}
export function order_form_list(body) {
    return req.get({
        url: service_url + '/user/order/list',
        body
    }).then(function (data) {
        return data
    })
}

export function getDictList(body) {
    return req.get({
        url: service_url + '/dict/list',
        body
    }).then(function (data) {
        return data
    })
}

// 支付宝支付
export function aliPayPrepare(body) {
    return req.postForm({
        url: service_url + '/pay/aliPay/prepare',
        body
    }).then(function (data) {
        return data
    })
}
